import { css } from 'styled-components';

export default ({ theme }) => css`
  background-color: ${theme.section.background};
`;
